<script>
  import * as restfulService from '../../services/restfulService'

  import AppGlobalLoader from './GlobalLoader'
  import AppHeader from './Header'
  import AppSidebar from './Sidebar'
  import AppNotification from './Notification'
  import {mapActions, mapGetters} from 'vuex'
  import bus from '@utils/bus'
  import {set} from '@utils/storage'
  import UpdateManagerPopup from './UpdateManager'

  const NETWORK_EVENTS = ['online', 'offline', 'load']

  export default {
    name: 'App',
    components: {UpdateManagerPopup, AppGlobalLoader, AppHeader, AppSidebar, AppNotification},
    data () {
      return {
        loaderMessage: 'Carregando Dados',
        internetAtiva: true,
        mostrarModalQuestionarios: false,
        questionarios: []
      }
    },
    watch: {
      isLogged: function (newValue, oldValue) {
        if (newValue) {
          this.getLimeSurvey()
        }
      }
    },
    computed: {
      ...mapGetters(['isLogged', 'isLoading', 'currentUser']),
      possuiQuestionarioObrigatorio: function () {
        return this.questionarios.length > 0 && this.questionarios.some(item => item.obrigatorio)
      }
    },
    mounted () {
      this.oneSignalInit()
      NETWORK_EVENTS.forEach(event => window.addEventListener(event, this.conexaoInternetAlterada))
      bus.$on('show-loader', (message) => {
        message = message || null
        this.showLoader(message)
      })
      bus.$on('hide-loader', () => this.hideLoader())
      setTimeout(() => {
        this.hideLoader()
        if (this.isLogged) {
          this.getLimeSurvey()
        }
      }, 300)
    },
    methods: {
      ...mapActions(['showLoader', 'hideLoader', 'showNotification']),
      oneSignalInit () {
        let OneSignal = window.OneSignal || []
        if (!OneSignal.initialized && typeof OneSignal.on === 'function') {
          OneSignal.push(
            ['init', {
              appId: 'b805ed9e-e91b-4975-b1cd-20370172e1d3',
              autoRegister: true,
              promptOptions: {
                actionMessage: 'Deseja receber notas, avaliações, eventos e novidades da URCAMP',
                acceptButtonText: 'Sim',
                cancelButtonText: 'Não, obrigado!',
                siteName: 'Sou URCAMP'
              }
            }],
            OneSignal.on('subscriptionChange', function () {
              OneSignal.getUserId(function (userId) {
                if (userId) {
                  set('onesignalid', userId)
                }
              })
            }),
            OneSignal.getUserId(function (userId) {
              if (userId) {
                set('onesignalid', userId)
              }
            })
          )
        }
      },
      getLimeSurvey () {
        restfulService.get('limesurvey')
          .then(response => {
            if (response && response.length > 0) {
              this.mostrarModalQuestionarios = true
              this.questionarios = response
            }
          })
          .catch(e => {
            console.log(e)
          })
      },
      conexaoInternetAlterada () {
        let internetAtiva = navigator.onLine || false
        if (!this.internetAtiva && internetAtiva) {
          this.showNotification({
            title: 'Conexão ativa',
            message: 'Sua internet está funcionando',
            timeout: 2000
          })
        } else if (this.internetAtiva && !internetAtiva) {
          this.showNotification({
            title: 'Conexão interrompida',
            message: 'Sua internet não parece estar funcionando',
            type: 'error',
            timeout: 0
          })
        }
        this.internetAtiva = internetAtiva
      }
    },
    beforeDestroy () {
      NETWORK_EVENTS.forEach(event => window.removeEventListener(event, this.conexaoInternetAlterada))
    }
  }
</script>

<template>
  <v-app>
    <AppGlobalLoader/>
    <AppNotification/>
    <AppHeader v-if="isLogged"/>
    <AppSidebar v-if="isLogged"/>
    <main class="main-content" v-bind:class="{'-logged': isLogged, '-loading': isLoading}">
      <router-view></router-view>
    </main>
    <v-dialog persistent max-width="600" v-model="mostrarModalQuestionarios">
      <v-card>
        <v-container grid-list-md text-xs-center>
          <h2>Questionários de avaliação docente</h2>
          <div class="subheading" style="padding: 15px 0;">
            <p style="text-align: justify">
              Olá! <br> Por favor, responda o(s) questionário(s) listado(s).
            </p>
          </div>
          <template v-for="(item, index) in questionarios">
            <div style="padding:0 0 15px 0;">
              <v-btn block v-bind:color="`${item.obrigatorio ? 'error' : 'success'}`"
                     large
                     target="_blank"
                     :href="item.url">
                <i class="fas fa-file-alt"></i>
                <span class="ml-2">{{item.obrigatorio ? '* ':''}}{{item.nome}}</span>
              </v-btn>
            </div>
          </template>
          <div class="body-1">
            (*) Questionários com asterisco são de preenchimento obrigatório<br>
            Após responder, atualize a página para liberar o acesso.
          </div>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click.native="mostrarModalQuestionarios = false"
                 v-if="!possuiQuestionarioObrigatorio">Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <UpdateManagerPopup/>
  </v-app>
</template>

<style src="assets/sass/app.scss" lang="scss"></style>
<style src="assets/sass/responsive.scss" lang="scss"></style>



// WEBPACK FOOTER //
// App.vue?f27e8428